import React, { useState, useEffect } from "react";
import API from "../axios";
import { motion } from "framer-motion";
import "../style/contact.css";

const Contacts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Corporate");

  
  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

  const isCorporate =
  empDetails?.branchname?.toLowerCase() === "corporate";

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const res = await API.get("/contacts");
      setData(res.data);
      console.log(res.data);
    } catch (err) {
      console.error("Error fetching contacts", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const filteredData = data.filter(
    (item) => item.location === activeTab
  );

  return (
    <div className="container mt-3 mb-5 mb-lg-0 pt-lg-3">
      {/* HEADER */}
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-4"
      >
        <h3 className="contact-title">Contacts</h3>

        {/* BUTTONS */}
        <div className="d-flex justify-content-center gap-3 mt-3 flex-wrap">
          <button
            className={`contact-btn ${
              activeTab === "Corporate" ? "active-btn" : ""
            }`}
            onClick={() => setActiveTab("Corporate")}
          >
            Corporate
          </button>

          <button
            className={`contact-btn ${
              activeTab === "Store" ? "active-btn" : ""
            }`}
            onClick={() => setActiveTab("Store")}
          >
            Store
          </button>
        </div>
      </motion.div>

      {/* LOADING */}
      {loading ? (
        <div className="text-center fw-bold mt-5">Loading...</div>
      ) : (
        <div className="row g-4">
          {filteredData.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-12" key={item.id}>
              <motion.div
                className="contact-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.25,
                  delay: index * 0.03
                }}
                whileHover={{ y: -3 }}
              >
                {/* <div className="contact-avatar">
                  {item.name.charAt(0)}
                </div> */}

            

                  <h5 className="contact-name">{item.name}</h5>

                  <p className="contact-designation m-lg-0 mb-2">
                    {item.designation}
                  </p>



                

                <div className="contact-info">
                  <span className="label">Department</span>
                  <span>{item.dept}</span>
                </div>

                  
                {/* <div className="contact-info">
                  <span className="label">Phone</span>
                  <a href={`tel:${item.phone}`}>
                    {item.phone}
                  </a>
                </div> */}

                {!(activeTab === "Corporate" && !isCorporate) && (
                  <div className="contact-info">
                    <span className="label">Phone</span>
                    <a href={`tel:${item.phone}`}>
                      {item.phone}
                    </a>
                  </div>
                )}

              </motion.div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Contacts;